import { CSSProperties } from 'react';

export const PageContent: React.FC<{
  children: React.ReactNode;
  style?: CSSProperties | undefined;
}> = (props) => {
  return (
    <main
      className={
        '' + 'max-w-[760px] ' + 'm-auto ' + 'pl-[1em] ' + 'pr-[1em] ' + 'my-20 ' + 'min-h-[62vh] '
      }
      style={props.style}
    >
      {props.children}
    </main>
  );
};
